import { useState, useEffect, useRef, useCallback } from 'react';
import './Hero.css';

import slide1 from '../../assets/slide1.png';
import slide2 from '../../assets/slide2.png';
import slide3 from '../../assets/slide3.png';
import slide4 from '../../assets/slide4.png';
import slide5 from '../../assets/slide5.png';
import mobile1 from '../../assets/mobile1.png';
import mobile2 from '../../assets/mobile2.png';
import mobile3 from '../../assets/mobile3.png';
import mobile4 from '../../assets/mobile4.png';
import mobile5 from '../../assets/mobile5.png';

const SLIDES = [
  {
    img: slide1,
    mobileImg: mobile1,
    label: 'Baby Shoot',
    category: 'Newborn · Baby Photography',
  },
  {
    img: slide2,
    mobileImg: mobile2,
    label: 'Baby Shoot',
    category: 'Newborn · Baby Photography',
  },
  {
    img: slide3,
    mobileImg: mobile3,
    label: 'Wedding Shoot',
    category: 'Wedding Photography',
  },
  {
    img: slide4,
    mobileImg: mobile4,
    label: 'Wedding Shoot',
    category: 'Wedding Photography',
  },
  {
    img: slide5,
    mobileImg: mobile5,
    label: 'Wedding Shoot',
    category: 'Wedding Photography',
  },
];

const INTERVAL = 7000;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener('resize', fn);

    return () => window.removeEventListener('resize', fn);
  }, []);

  return isMobile;
}

export default function Hero() {
  const [cur, setCur] = useState(0);
  const [prev, setPrev] = useState(null);
  const [transitioning, setTrans] = useState(false);

  const timerRef = useRef(null);

  const isMobile = useIsMobile();

  const goSlide = useCallback(
    (n) => {
      if (transitioning || n === cur) return;

      setTrans(true);
      setPrev(cur);
      setCur(n);

      clearInterval(timerRef.current);

      timerRef.current = setInterval(() => {
        setCur((c) => (c + 1) % SLIDES.length);
      }, INTERVAL);

      setTimeout(() => {
        setPrev(null);
        setTrans(false);
      }, 1200);
    },
    [cur, transitioning]
  );

  const nextSlide = useCallback(
    () => goSlide((cur + 1) % SLIDES.length),
    [cur, goSlide]
  );

  const prevSlide = useCallback(
    () => goSlide((cur - 1 + SLIDES.length) % SLIDES.length),
    [cur, goSlide]
  );

  /* Auto Slide */

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCur((c) => (c + 1) % SLIDES.length);
    }, INTERVAL);

    return () => clearInterval(timerRef.current);
  }, []);

  /* Keyboard */

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'ArrowRight') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
    };

    window.addEventListener('keydown', onKey);

    return () => window.removeEventListener('keydown', onKey);
  }, [nextSlide, prevSlide]);

  /* Touch Swipe */

  const touchStartX = useRef(null);

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;

    const diff = touchStartX.current - e.changedTouches[0].clientX;

    if (Math.abs(diff) > 40) {
      diff > 0 ? nextSlide() : prevSlide();
    }

    touchStartX.current = null;
  };

  return (
    <section
      id="home"
      className="hero"
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {/* Slides */}
      <div className="slide-bg">
        {SLIDES.map((slide, i) => (
          <div
            key={i}
            className={`slide ${i === cur ? 'active' : ''} ${
              i === prev ? 'prev' : ''
            }`}
            style={{
              backgroundImage: `url(${
                 isMobile ? slide.mobileImg : slide.img
              })`,
              backgroundPosition: isMobile
                ? slide.mobilePos
                : 'center center',
            }}
          />
        ))}
      </div>

      {/* Overlay */}
      <div className="hero-overlay" />

      {/* Dots */}
      <div className="slide-dots">
        {SLIDES.map((_, i) => (
          <div
            key={i}
            className={`sdot ${i === cur ? 'active' : ''}`}
            onClick={() => goSlide(i)}
          >
            <div className="sdot-fill" />
          </div>
        ))}
      </div>

      {/* Arrows */}
      <div className="slide-arrows">
        <div className="sarrow" onClick={prevSlide}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <path d="M19 12H5M11 6l-6 6 6 6" />
          </svg>
        </div>

        <div className="sarrow" onClick={nextSlide}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </div>
      </div>
    </section>
  );
}